import React from "react";
import { NextPage } from "next";
import CommonLayout from "@src/layouts/CommonLayout";
import { Box, Divider, Heading, Text } from "@chakra-ui/react";

const BusinessPage: NextPage = () => {
  return (
    <CommonLayout>
      <Box
        display="flex"
        flexDirection="column"
        m={3}
        mx="auto"
        mb={50}
        maxW={600}
      >
        <Heading
          display="inline-block"
          m={3}
          my={[5, 10]}
          pb={3}
          fontWeight="bold"
          fontSize={24}
          textAlign="center"
          borderBottom="3px solid"
        >
          会社概要
        </Heading>
        <Box display="flex" flexDirection="column" textAlign="left">
          <Box p={3} display="flex" justifyContent="space-between">
            <Text fontWeight="bold">会社名</Text>
            <div>株式会社ZERO COLOR</div>
          </Box>
          <Divider />
          <Box p={3} display="flex" justifyContent="space-between">
            <Text fontWeight="bold">本籍地</Text>
            <div>兵庫県神戸市西区美賀多台1丁目2番地</div>
          </Box>
          <Divider />
          <Box p={3} display="flex" justifyContent="space-between">
            <Text fontWeight="bold">設立年月日</Text>
            <div>2018年12月</div>
          </Box>
          <Divider />
          <Box p={3} display="flex" justifyContent="space-between">
            <Text fontWeight="bold">代表取締役</Text>
            <div>野山 嶺</div>
          </Box>
          <Divider />
          <Box p={3} display="flex" justifyContent="space-between">
            <Text fontWeight="bold">事業内容</Text>
            <div>FASTLANE・レツミルメディアの運営</div>
          </Box>
        </Box>
      </Box>
    </CommonLayout>
  );
};

export default BusinessPage;
